module.exports = __webpack_public_path__ + "img/duquesne-university-logo.85a780a1.png";